import React, { useEffect, useState } from 'react';

import event from 'assets/icons/Event.svg';
import { LocalEvents } from 'shared/components/LocalEvents';
import EventDetailView from 'shared/components/EventDetailView';
import { LocalEvent } from 'core/API/local-events';
import Sidebar from 'core/components/Sidebar/Sidebar';
import Modal from 'core/components/Modal/Modal';
import useModal from 'core/hooks/useModal';
import AddEventModal from 'module/schedule/Modals/AddEventModal/AddEventModal';
import CustomerDatabaseModal from 'module/schedule/Modals/CustomerDatabase/CustomerDatabaseModal';
import { useWorkplacesContext } from 'module/workplaces/context/WorkplacesContext';
import { usePermissionCheck } from 'core/hooks/usePermissionCheck';
import CustomerTable from '../../components/featured/customer-table/CustomerTable';

import EventsMonth from './pages/EventsMonth';
import './Events.style.scss';

export default function Events(): JSX.Element {
	const { workplaceId } = useWorkplacesContext();
	const [selectedLocalEvent, setSelectedLocalEvent] = useState<LocalEvent | null>(null);

	const { hasModuleViewPermission } = usePermissionCheck();
	const canViewEvents = hasModuleViewPermission('Events');

	const {
		open: isAddEventModalOpen,
		closeModal: closeAddEventModal,
	} = useModal();

	const {
		open: isCustomerDatabaseModalOpen,
		closeModal: closeCustomerDatabaseModal,
	} = useModal();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	if (!canViewEvents) {
		return (
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					minHeight: 'calc(100vh - 200px)',
					padding: '20px',
				}}
			>
				<div
					style={{
						backgroundColor: '#fff',
						borderRadius: '10px',
						boxShadow: '0 2px 5px rgba(0, 0, 0, 0.06)',
						padding: '40px 60px',
						textAlign: 'center',
						maxWidth: '500px',
						width: '100%',
					}}
				>
					<h2
						style={{
							margin: '0 0 16px 0',
							fontSize: '24px',
							fontWeight: 600,
							color: '#333',
						}}
					>
						Access Denied
					</h2>
					<p
						style={{
							margin: 0,
							fontSize: '16px',
							color: '#666',
							lineHeight: '1.5',
						}}
					>
						You do not have permission to view events.
					</p>
				</div>
			</div>
		);
	}

	return (
		<>
			{selectedLocalEvent && (
				<EventDetailView
					event={selectedLocalEvent}
					onClose={() => setSelectedLocalEvent(null)}
					eventType="local-event"
				/>
			)}

			{/* Hidden rather than unmounted so calendar state survives viewing a local event */}
			<section
				className="Content EventsContent"
				style={selectedLocalEvent ? { display: 'none' } : undefined}
			>
				<div className="events-page-inner">
					<div className="events-top-widgets">
						<div className="events-top-widget card alerts">
							<div className="events-header">
								<h2>Mabel A.I. - Local Events</h2>
							</div>
							<LocalEvents workplaceId={workplaceId} onEventClick={setSelectedLocalEvent} />
						</div>
						<div className="events-top-widget">
							<CustomerTable title="Customer" />
						</div>
					</div>
					<div className="events-calendar-section">
						<EventsMonth showBackButton={false} />
					</div>
				</div>
			</section>

			{isAddEventModalOpen ? (
				<Sidebar
					icon={event}
					title="Create a new event"
					close={closeAddEventModal}
					render={() => <AddEventModal closeEventModal={closeAddEventModal} />}
				/>
			) : null}

			{isCustomerDatabaseModalOpen ? (
				<Modal
					icon={event}
					title="Customer database"
					close={closeCustomerDatabaseModal}
					bigModal
					render={() => <CustomerDatabaseModal closeModal={closeCustomerDatabaseModal} />}
				/>
			) : null}
		</>
	);
}
